<template>
  <ModalContainer
    :showModal="showModal"
    :title="isEdit ? 'Edit Reminder' : 'Create New Reminder'"
    @closeModal="closeModal"
  >
    <div id="modal-body" class="p-6">
      <AlertDanger
        v-if="alert_danger"
        :text="alert_text"
        @closeAlertDanger="hideAlertDanger()"
      />
      <InputForm
        id="reminder-title"
        input_class="w-full mb-5"
        label="Title"
        label_class="mb-1 block text-start"
        type="text"
        placeholder="e.g. Sulam Alis"
        v-model="reminder.title"
      />
      <InputForm
        id="remind_date"
        input_class="w-full mb-5"
        label="Remind Date"
        label_class="mb-1 block text-start"
        type="date"
        v-model="reminder.remind_date"
      />
      <Select
        id="reminder-select-customer"
        label="Customer"
        option_placeholder="Select Customer"
        select_class="w-full mb-4"
        valueKey="id"
        labelKey="name"
        :options="allCustomers"
        v-model="reminder.customer_id"
      />
      <TextArea
        v-if="isEdit"
        label="Customer Answer"
        textarea_class="mb-4"
        rows="4"
        v-model="reminder.customer_answer"
      />
    </div>
    <div class="modal-footer pb-6">
      <div class="flex justify-center gap-2">
        <Button id="close-modal" button_text="Close" @click="closeModal" />
        <SubmitButton
          @click="submit()"
          :is_loading="loadingSubmit"
          :is_disabled="loadingSubmit"
          id="submit"
          button_text="Submit"
        />
      </div>
    </div>
  </ModalContainer>
</template>

<script>
import InputForm from "@/components/form/InputForm.vue";
import AlertDanger from "@/components/alerts/AlertDanger.vue";
import ModalContainer from "@/components/modals/ModalContainer.vue";
import Button from "@/components/buttons/Button.vue";
import SubmitButton from "../form/SubmitButton.vue";
import Select from "@/components/form/Select.vue";
import TextArea from "../form/TextArea.vue";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalAddEditReminder",
  props: {
    reminderData: {
      type: Object,
      default: {},
    },
  },
  emits: ["openAlertSuccess", "closeModal"],
  components: {
    Switch,
    SwitchGroup,
    SwitchLabel,
    InputForm,
    AlertDanger,
    ModalContainer,
    Button,
    SubmitButton,
    Select,
    TextArea,
  },
  data() {
    return {
      showModal: true,
      alert_danger: false,
      alert_text: "",

      isEdit: false,
      loadingSubmit: false,

      reminder: {
        id: null,
        title: "",
        remind_date: null,
        customer_id: "",
        status: "not done",
        customer_answer: "",
      },
    };
  },
  created() {
    this.$store.dispatch("customers/fetchCustomers");

    if (this.reminderData) {
      this.isEdit = true;
      this.reminder.id = parseInt(this.reminderData.id);
      this.reminder.title = this.reminderData.title;
      this.reminder.remind_date = this.formatDate(this.reminderData.remind_date);
      this.reminder.customer_id = parseInt(this.reminderData.customer_id);
      this.reminder.status = this.reminderData.status;
      this.reminder.customer_answer = this.reminderData.customer_answer;
    }
  },
  computed: {
    ...mapGetters("customers", ["allCustomers"]),
  },
  methods: {
    ...mapActions("reminders", ["createReminder", "updateReminder"]),

    closeModal() {
      this.showModal = false;
      this.$emit("closeModal");
    },
    formatDate(stringDate) {
      const date = new Date(stringDate);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    },
    async submit() {
      if (!this.reminder.title) {
        this.alert_danger = true;
        this.alert_text = "Title cannot be empty!";
        return;
      }
      if (!this.reminder.remind_date) {
        this.alert_danger = true;
        this.alert_text = "Remind date cannot be empty!";
        return;
      }
      if (!this.reminder.customer_id) {
        this.alert_danger = true;
        this.alert_text = "Customer cannot be empty!";
        return;
      }
      // console.log("reminder: ", this.reminder);                        
      try {
        this.loadingSubmit = true;
        if (this.isEdit) {
          await this.updateReminder(this.reminder);
          // this.$emit("openAlertSuccess_CustomerUpdated");
        }
        else {
          await this.createReminder(this.reminder);
          // this.$emit("openAlertSuccess_CustomerCreated");
        }
        this.closeModal();
      }
      catch (error) {
        console.error(error);
        this.loadingSubmit = false;
      }
      finally {
        this.loadingSubmit = false;
      }
    },
    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = "";
    },
  },
};
</script>
